import type {AppLanguageCode} from '../shared/i18n/app-language';

// Generated by scripts/generate-guide-seo.mjs. Full article text stays in the lazy guides module.
export const GUIDE_SEO_CONTENT: Record<string, Record<AppLanguageCode, {metaTitle: string; metaDescription: string}>> = {
  "administration-audits": {
    "uk": {
      "metaTitle": "Аудит файлів і бази даних для адміністратора — Invemory",
      "metaDescription": "Перегляньте збережені аудити Invemory, перевірте посилання на файли, відфільтруйте об’єкти та запустіть новий вимір. Посібник для адміністратора на сайті й Android."
    },
    "en": {
      "metaTitle": "File storage and database audits for administrators — Invemory",
      "metaDescription": "Read saved Invemory audits, check file references, filter stored objects, and run a fresh measurement. An administrator guide for the website and Android app."
    },
    "de": {
      "metaTitle": "Audits für Dateispeicher und Datenbank — Invemory",
      "metaDescription": "Lesen Sie gespeicherte Invemory-Audits, prüfen Sie Dateireferenzen, filtern Sie Objekte und starten Sie eine neue Messung. Eine Anleitung für Administratoren auf Website und Android."
    },
    "ru": {
      "metaTitle": "Аудит файлов и базы данных для администратора — Invemory",
      "metaDescription": "Просмотрите сохранённые аудиты Invemory, проверьте ссылки на файлы, отфильтруйте объекты и запустите новое измерение. Руководство для администратора на сайте и Android."
    }
  },
  "appearance": {
    "uk": {
      "metaTitle": "Власні кольори та швидкий доступ — Invemory",
      "metaDescription": "Виберіть світлу, темну чи власну палітру Invemory. Налаштуйте кольори та язичок швидкого доступу й дізнайтеся, як працює оформлення публічних сторінок і входу."
    },
    "en": {
      "metaTitle": "Personal colors and quick access — Invemory",
      "metaDescription": "Choose a light, dark or personal Invemory palette. Adjust colors and the quick access handle, and understand appearance on public pages and during sign-in."
    },
    "de": {
      "metaTitle": "Eigene Farben und Schnellzugriff — Invemory",
      "metaDescription": "Wählen Sie eine helle, dunkle oder persönliche Invemory-Palette. Passen Sie Farben und Schnellzugriff an und erfahren Sie, wie öffentliche Seiten und die Anmeldung aussehen."
    },
    "ru": {
      "metaTitle": "Собственные цвета и быстрый доступ — Invemory",
      "metaDescription": "Выберите светлую, тёмную или собственную палитру Invemory. Настройте цвета и язычок быстрого доступа и узнайте, как работает оформление публичных страниц и входа."
    }
  },
  "basket-needs": {
    "uk": {
      "metaTitle": "Потреби в кошику: запас, локація та пріоритет — Invemory",
      "metaDescription": "Розберіться, скільки товару є та скільки потрібно придбати для кожної локації. Перевірте пріоритет, доступні зміни й історію на сайті та в Android."
    },
    "en": {
      "metaTitle": "Basket needs: stock, location and priority — Invemory",
      "metaDescription": "Understand stock and how much to buy for each location. Check the priority, available changes and request history on the website and in Android."
    },
    "de": {
      "metaTitle": "Bedarf im Einkaufskorb: Vorrat, Ort und Priorität — Invemory",
      "metaDescription": "Lesen Sie den Vorrat und die benötigte Einkaufsmenge je Lagerort. Prüfen Sie Prioritäten, verfügbare Änderungen und den Auftragsverlauf im Web und in Android."
    },
    "ru": {
      "metaTitle": "Потребности в корзине: запас, место и приоритет — Invemory",
      "metaDescription": "Разберитесь, сколько товара есть и сколько нужно купить для каждого места. Проверьте приоритет, доступные изменения и историю на сайте и в Android."
    }
  },
  "basket-planned-price": {
    "uk": {
      "metaTitle": "Планова ціна та бюджет кошика — Invemory",
      "metaDescription": "Задайте ціну за одиницю ручної чи автоматичної потреби. Оцініть вартість залишку окремо за валютами та перевірте фактичну ціну під час придбання."
    },
    "en": {
      "metaTitle": "Planned prices and basket budget — Invemory",
      "metaDescription": "Set a unit price for a manual or automatic shopping request. Estimate the remaining cost separately by currency and check the actual price during acquisition."
    },
    "de": {
      "metaTitle": "Planpreise und Budget im Einkaufskorb — Invemory",
      "metaDescription": "Legen Sie einen Preis pro Einheit für manuelle oder automatische Einkaufsaufträge fest. Prüfen Sie das Restbudget je Währung und den tatsächlichen Kaufpreis."
    },
    "ru": {
      "metaTitle": "Плановая цена и бюджет корзины — Invemory",
      "metaDescription": "Задайте цену за единицу ручного или автоматического заказа. Оцените стоимость остатка отдельно по валютам и проверьте фактическую цену при покупке."
    }
  },
  "basket-purchase-consumption": {
    "uk": {
      "metaTitle": "Використання покупки з кошика без розміщення — Invemory",
      "metaDescription": "Позначте частину або всю власну покупку як використану без розміщення, збережіть журнал і повторно виберіть її опис за штрихкодом на вебсайті та в Android."
    },
    "en": {
      "metaTitle": "Use a basket purchase without placing it — Invemory",
      "metaDescription": "Mark all or part of your private purchase as used without placing it, retain the purchase journal and reuse its product details by barcode on the website and Android."
    },
    "de": {
      "metaTitle": "Einkauf ohne Einlagerung verbrauchen — Invemory",
      "metaDescription": "Erfassen Sie den vollständigen oder teilweisen Verbrauch eines privaten Einkaufs, behalten Sie den Journaleintrag und nutzen Sie die Produktdaten erneut per Barcode — auf der Website und in Android."
    },
    "ru": {
      "metaTitle": "Использование покупки из корзины без размещения — Invemory",
      "metaDescription": "Отметьте часть или всю свою покупку как использованную без размещения, сохраните журнал и снова выберите её описание по штрихкоду на сайте и в Android."
    }
  },
  "basket-purchase-photo": {
    "uk": {
      "metaTitle": "Фото товару перед придбанням у кошику — Invemory",
      "metaDescription": "Звірте назву й головне фото замовлення, відкрийте галерею та перегорніть знімки перед придбанням у вебсайті й Android."
    },
    "en": {
      "metaTitle": "Check product photos before a basket purchase — Invemory",
      "metaDescription": "Check a shopping request’s name and main photo, open its gallery and browse saved images before buying on the website or Android."
    },
    "de": {
      "metaTitle": "Artikelfotos vor dem Kauf im Einkaufskorb prüfen — Invemory",
      "metaDescription": "Prüfen Sie Name und Hauptfoto eines Einkaufsauftrags, öffnen Sie die Galerie und blättern Sie vor dem Kauf auf der Website und in Android durch gespeicherte Fotos."
    },
    "ru": {
      "metaTitle": "Фото товара перед покупкой в корзине — Invemory",
      "metaDescription": "Сверьте название и главное фото заказа, откройте галерею и пролистайте сохранённые снимки перед покупкой на сайте и в Android."
    }
  },
  "bulk-move": {
    "uk": {
      "metaTitle": "Групове переміщення речей — Invemory",
      "metaDescription": "Виберіть кілька записів у контейнері, уточніть вибір усередині групи та перенесіть речі разом на вебсайті й в Android."
    },
    "en": {
      "metaTitle": "Move multiple items together — Invemory",
      "metaDescription": "Select several records in a container, refine a same-name group selection and move them together on the website and in Android."
    },
    "de": {
      "metaTitle": "Mehrere Gegenstände verschieben — Invemory",
      "metaDescription": "Wähle mehrere Datensätze in einem Container, passe die Auswahl einer gleichnamigen Gruppe an und verschiebe sie im Web oder in Android gemeinsam."
    },
    "ru": {
      "metaTitle": "Групповое перемещение вещей — Invemory",
      "metaDescription": "Выберите несколько записей в контейнере, уточните выбор внутри одноимённой группы и перенесите вещи вместе на сайте и в Android."
    }
  },
  "copy-item": {
    "uk": {
      "metaTitle": "Копіювання речей без повторного введення — Invemory",
      "metaDescription": "Створіть окремий предмет із наявного. Перевірте назву й кількість; нова копія фасованого запасу починається з повного вмісту."
    },
    "en": {
      "metaTitle": "Copy items without entering everything again — Invemory",
      "metaDescription": "Create a separate item from an existing one. Review its name and quantity; a new copy of packaged stock starts with full contents."
    },
    "de": {
      "metaTitle": "Gegenstände ohne erneute Dateneingabe kopieren — Invemory",
      "metaDescription": "Erstellen Sie einen eigenen Gegenstand aus einem vorhandenen. Prüfen Sie Name und Menge; eine neue Kopie verpackten Vorrats beginnt mit vollem Inhalt."
    },
    "ru": {
      "metaTitle": "Копирование вещей без повторного ввода — Invemory",
      "metaDescription": "Создайте отдельный предмет на основе существующего. Проверьте название и количество; новая копия фасованного запаса начинает с полного содержимого."
    }
  },
  "correct-packaging": {
    "uk": {
      "metaTitle": "Виправлення тари предмета або покупки 1:1 — Invemory",
      "metaDescription": "Виправте коробку, пакунок або пляшку через попередній перегляд. Збережіть кількість, вміст, залишок і ціну та перевірте окрему історію на вебсайті й в Android."
    },
    "en": {
      "metaTitle": "Correct item or purchase packaging at a 1:1 ratio — Invemory",
      "metaDescription": "Correct boxes, packages or bottles through a preview. Preserve quantity, contents, remainder and price, then check the separate history on the website and in Android."
    },
    "de": {
      "metaTitle": "Verpackung von Gegenstand oder Kauf 1:1 korrigieren — Invemory",
      "metaDescription": "Prüfen Sie die Korrektur von Kartons, Packungen oder Flaschen vor dem Speichern. Menge, Inhalt, Rest und Preis bleiben erhalten; der eigene Verlauf zeigt die Änderung."
    },
    "ru": {
      "metaTitle": "Исправление упаковки предмета или покупки 1:1 — Invemory",
      "metaDescription": "Исправьте коробку, упаковку или бутылку через предварительный просмотр. Сохраните количество, содержимое, остаток и цену и проверьте отдельную историю на сайте и в Android."
    }
  },
  "favorites": {
    "uk": {
      "metaTitle": "Обрані речі й контейнери — Invemory",
      "metaDescription": "Додайте потрібні речі й контейнери до обраного, відфільтруйте список за типом і поверніть випадково прибраний запис. Інструкція для сайту й Android."
    },
    "en": {
      "metaTitle": "Favorite items and containers — Invemory",
      "metaDescription": "Add items and containers to Favorites, filter them by type, and undo an accidental removal. Follow the workflow on the website and Android."
    },
    "de": {
      "metaTitle": "Gegenstände und Container als Favoriten — Invemory",
      "metaDescription": "Fügen Sie Gegenstände und Container zu Favoriten hinzu, filtern Sie nach Typ und machen Sie versehentliches Entfernen rückgängig. Für Website und Android."
    },
    "ru": {
      "metaTitle": "Избранные вещи и контейнеры — Invemory",
      "metaDescription": "Добавляйте вещи и контейнеры в избранное, фильтруйте список по типу и отменяйте случайное удаление отметки. Инструкция для сайта и Android."
    }
  },
  "find-items": {
    "uk": {
      "metaTitle": "Пошук речей і контейнерів — Invemory",
      "metaDescription": "Знайдіть річ за назвою чи описом, перевірте її місце зберігання та налаштуйте фільтр наявності на вебсайті й в Android."
    },
    "en": {
      "metaTitle": "Find items and containers — Invemory",
      "metaDescription": "Search by name or description, check where an item is stored and use availability filters on the website and in Android."
    },
    "de": {
      "metaTitle": "Gegenstände und Container finden — Invemory",
      "metaDescription": "Suchen Sie nach Namen oder Beschreibung, prüfen Sie den Aufbewahrungsort und filtern Sie nach Verfügbarkeit auf der Website und in Android."
    },
    "ru": {
      "metaTitle": "Поиск вещей и контейнеров — Invemory",
      "metaDescription": "Найдите вещь по названию или описанию, проверьте место хранения и настройте фильтр наличия на сайте и в Android."
    }
  },
  "inventory-groups": {
    "uk": {
      "metaTitle": "Групи предметів, кількість і фасування — Invemory",
      "metaDescription": "Розгорніть групу предметів у контейнері, перевірте окремі запаси й сумарний вміст. Дізнайтеся, як штрихкод і списання впливають на редагування."
    },
    "en": {
      "metaTitle": "Item groups, quantities and packaging — Invemory",
      "metaDescription": "Expand an item group in a container and check individual stock and total contents. Learn how barcodes and content write-off affect editing."
    },
    "de": {
      "metaTitle": "Gegenstandsgruppen, Menge und Packungsinhalt — Invemory",
      "metaDescription": "Klappen Sie eine Gruppe im Container auf und prüfen Sie einzelne Vorräte und den Gesamtinhalt. Erfahren Sie, wie Strichcodes und Ausbuchen die Bearbeitung beeinflussen."
    },
    "ru": {
      "metaTitle": "Группы предметов, количество и фасовка — Invemory",
      "metaDescription": "Разверните группу предметов в контейнере, проверьте отдельные запасы и общий объём содержимого. Узнайте, как штрихкод и списание влияют на редактирование."
    }
  },
  "item-history": {
    "uk": {
      "metaTitle": "Останні зміни й історія предметів — Invemory",
      "metaDescription": "Перегляньте історію предмета, відфільтруйте події за типом і датою, порівняйте зміни даних та залишок вмісту до й після списання."
    },
    "en": {
      "metaTitle": "Recent changes and item history — Invemory",
      "metaDescription": "Open item history, filter events by type and date, compare data changes and check remaining contents before and after a write-off."
    },
    "de": {
      "metaTitle": "Letzte Änderungen und Gegenstandsverlauf — Invemory",
      "metaDescription": "Öffnen Sie den Gegenstandsverlauf, filtern Sie nach Typ und Datum und vergleichen Sie Datenänderungen sowie den Restinhalt vor und nach einer Entnahme."
    },
    "ru": {
      "metaTitle": "Последние изменения и история предметов — Invemory",
      "metaDescription": "Откройте историю предмета, отфильтруйте события по типу и дате, сравните изменения данных и остаток содержимого до и после списания."
    }
  },
  "item-prices": {
    "uk": {
      "metaTitle": "Сума, валюта й вартість покупки — Invemory",
      "metaDescription": "Запишіть ціну за одиницю, перевірте валюту й вартість покупки. Виправляйте кількість, користуйтеся кроком −/+ і зберігайте введену ціну після помилки."
    },
    "en": {
      "metaTitle": "Purchase amount, currency and total value — Invemory",
      "metaDescription": "Record a unit price, check currency and purchase value, and correct quantity errors. Use whole-unit steps for packages while keeping the entered price."
    },
    "de": {
      "metaTitle": "Betrag, Währung und Einkaufswert — Invemory",
      "metaDescription": "Erfassen Sie Einzelpreis, Währung und Einkaufswert. Korrigieren Sie Mengenfehler und ändern Sie Packungen in ganzen Schritten, ohne den Preis neu einzugeben."
    },
    "ru": {
      "metaTitle": "Сумма, валюта и стоимость покупки — Invemory",
      "metaDescription": "Запишите цену за единицу, проверьте валюту и стоимость покупки. Исправляйте количество, используйте шаг −/+ и сохраняйте введённую цену после ошибки."
    }
  },
  "items": {
    "uk": {
      "metaTitle": "Предмети: створення, редагування й видалення — Invemory",
      "metaDescription": "Додавайте, редагуйте й видаляйте предмети в Invemory. Дізнайтеся, як перевірити збережену чернетку та повторити збереження після помилки у web і Android."
    },
    "en": {
      "metaTitle": "Add, edit and delete inventory items — Invemory",
      "metaDescription": "Add, edit and delete items in Invemory. Learn how to check a retained draft and explicitly retry a failed save on the web and Android."
    },
    "de": {
      "metaTitle": "Gegenstände hinzufügen, bearbeiten und löschen — Invemory",
      "metaDescription": "Gegenstände in Invemory hinzufügen, bearbeiten und löschen. Nach einem Speicherfehler den erhaltenen Entwurf prüfen und im Web oder auf Android erneut speichern."
    },
    "ru": {
      "metaTitle": "Предметы: создание, редактирование и удаление — Invemory",
      "metaDescription": "Добавляйте, редактируйте и удаляйте предметы в Invemory. Узнайте, как проверить сохранённый черновик и явно повторить сохранение после ошибки в web и Android."
    }
  },
  "move-inventory": {
    "uk": {
      "metaTitle": "Переміщення речей між контейнерами — Invemory",
      "metaDescription": "Перемістіть предмет або контейнер, починаючи з речі чи з меню місця призначення. Перевірте повний шлях і результат на сайті та Android."
    },
    "en": {
      "metaTitle": "Move items between containers — Invemory",
      "metaDescription": "Move an item or container from its record or start from the destination container menu. Check the full path and result on the website and Android."
    },
    "de": {
      "metaTitle": "Gegenstände in andere Container verschieben — Invemory",
      "metaDescription": "Verschieben Sie Gegenstände oder Behälter vom Datensatz oder vom Menü des Zielbehälters aus. Prüfen Sie den vollständigen Pfad und das Ergebnis im Web und auf Android."
    },
    "ru": {
      "metaTitle": "Перемещение вещей между контейнерами — Invemory",
      "metaDescription": "Переместите предмет или контейнер из его карточки либо начните с меню целевого контейнера. Проверьте полный путь и результат на сайте и Android."
    }
  },
  "photo-gallery": {
    "uk": {
      "metaTitle": "Перегляд, масштабування та галерея фото — Invemory",
      "metaDescription": "Роздивіться фото предметів, контейнерів і товарів у Invemory: гортання, збільшення, переміщення та повний екран у вебверсії й Android."
    },
    "en": {
      "metaTitle": "View, zoom and browse photos — Invemory",
      "metaDescription": "Inspect item, container and product photos in Invemory. Learn to browse, zoom, pan and use fullscreen on the website and Android."
    },
    "de": {
      "metaTitle": "Fotos ansehen, vergrößern und durchblättern — Invemory",
      "metaDescription": "Betrachten Sie Fotos von Gegenständen, Containern und Produkten in Invemory: Bildwechsel, Zoom, Verschieben und Vollbild im Web und auf Android."
    },
    "ru": {
      "metaTitle": "Просмотр, увеличение и галерея фото — Invemory",
      "metaDescription": "Рассмотрите фото предметов, контейнеров и товаров в Invemory: перелистывание, увеличение, перемещение и полный экран на сайте и в Android."
    }
  },
  "price-history": {
    "uk": {
      "metaTitle": "Історія ціни та виправлення покупки — Invemory",
      "metaDescription": "Перегляньте дати, авторів, валюти й основу ціни групи товару. Виправте суму та валюту через журнал покупок, поки є нерозміщений залишок."
    },
    "en": {
      "metaTitle": "Price history and purchase correction — Invemory",
      "metaDescription": "Review dates, authors, currencies and price bases for a product group. Correct an amount and currency in Purchase journal while an unplaced remainder is available."
    },
    "de": {
      "metaTitle": "Preisverlauf und Einkaufskorrektur — Invemory",
      "metaDescription": "Prüfen Sie Datum, Autor, Währung und Preisbasis einer Produktgruppe. Korrigieren Sie Betrag und Währung im Einkaufsjournal, solange ein Rest nicht eingelagert ist."
    },
    "ru": {
      "metaTitle": "История цены и исправление покупки — Invemory",
      "metaDescription": "Посмотрите даты, авторов, валюты и основу цены группы товара. Исправьте сумму и валюту через журнал покупок, пока есть неразмещённый остаток."
    }
  },
  "privacy-settings": {
    "uk": {
      "metaTitle": "Налаштування аналітики на сайті та Android — Invemory",
      "metaDescription": "Дізнайтеся, як дозволити або вимкнути необов’язкову аналітику Invemory у браузері та Android-застосунку й де знайти поточний стан згоди."
    },
    "en": {
      "metaTitle": "Website and Android analytics preferences — Invemory",
      "metaDescription": "Learn how to allow or disable optional Invemory analytics in your browser and Android app, and where to check your current choice."
    },
    "de": {
      "metaTitle": "Analyse-Einstellungen für Website und Android — Invemory",
      "metaDescription": "Erlauben oder deaktivieren Sie die optionale Invemory-Analyse im Browser und in der Android-App. So prüfen und ändern Sie Ihre Auswahl."
    },
    "ru": {
      "metaTitle": "Настройки аналитики на сайте и Android — Invemory",
      "metaDescription": "Узнайте, как разрешить или отключить необязательную аналитику Invemory в браузере и Android-приложении и где проверить текущий выбор."
    }
  },
  "quick-navigation": {
    "uk": {
      "metaTitle": "Швидка навігація на сайті й Android — Invemory",
      "metaDescription": "П’ять швидких переходів, переміщення язичка та прозорість на пристрої. Клавіатура на сайті й Android Назад у навігації Invemory."
    },
    "en": {
      "metaTitle": "Quick navigation on the website and Android — Invemory",
      "metaDescription": "Use five quick shortcuts, move the edge handle, and adjust device transparency. Learn website keyboard controls and Android Back in Invemory."
    },
    "de": {
      "metaTitle": "Schnellzugriff auf Website und Android — Invemory",
      "metaDescription": "Nutzen Sie fünf Schnellzugriffe, verschieben Sie den Randgriff und ändern Sie seine Transparenz. Mit Website-Tastatursteuerung und Android Zurück."
    },
    "ru": {
      "metaTitle": "Быстрая навигация на сайте и Android — Invemory",
      "metaDescription": "Пять быстрых переходов, перемещение язычка и прозрачность на устройстве. Клавиатура на сайте и Android Назад в навигации Invemory."
    }
  },
  "regional-settings": {
    "uk": {
      "metaTitle": "Мова, формат дат і робочі валюти — Invemory",
      "metaDescription": "Оберіть мову Invemory, зручний формат дат, часовий пояс і робочі валюти. Покроковий посібник для вебверсії та Android зі справжніми скріншотами."
    },
    "en": {
      "metaTitle": "Language, date format, and working currencies — Invemory",
      "metaDescription": "Choose your Invemory language, date format, timezone, and working currencies. Follow the website and Android steps with real application screenshots."
    },
    "de": {
      "metaTitle": "Sprache, Datumsformat und Arbeitswährungen — Invemory",
      "metaDescription": "Wählen Sie Sprache, Datumsformat, Zeitzone und Arbeitswährungen in Invemory. Eine Anleitung für Website und Android mit echten Bildschirmaufnahmen."
    },
    "ru": {
      "metaTitle": "Язык, формат дат и рабочие валюты — Invemory",
      "metaDescription": "Выберите язык Invemory, формат дат, часовой пояс и рабочие валюты. Пошаговое руководство для сайта и Android с настоящими скриншотами."
    }
  },
  "shared-purchases": {
    "uk": {
      "metaTitle": "Спільне замовлення та передача покупки — Invemory",
      "metaDescription": "Поділіться ручним замовленням із довіреним контактом, запишіть часткову покупку, передайте її замовнику й розмістіть у контейнері на вебсайті та в Android."
    },
    "en": {
      "metaTitle": "Share a shopping request and hand over a purchase — Invemory",
      "metaDescription": "Share a manual shopping request with a trusted contact, record a partial purchase, hand it over and place it in the requester’s container on the website and Android."
    },
    "de": {
      "metaTitle": "Einkaufsauftrag teilen und Einkauf übergeben — Invemory",
      "metaDescription": "Teilen Sie einen manuellen Einkaufsauftrag mit einem vertrauenswürdigen Kontakt, erfassen Sie einen Teilkauf und übergeben und lagern Sie den Einkauf ein — auf der Website und in Android."
    },
    "ru": {
      "metaTitle": "Общий заказ и передача покупки — Invemory",
      "metaDescription": "Поделитесь ручным заказом с доверенным контактом, запишите частичную покупку, передайте её заказчику и разместите в контейнере на сайте и в Android."
    }
  },
  "shops": {
    "uk": {
      "metaTitle": "Магазини: додавання, вибір і відновлення — Invemory",
      "metaDescription": "Упорядкуйте власний довідник магазинів. Вибирайте наявний магазин без втрати чернетки покупки, розрізняйте дублікати й відновлюйте архівні назви на сайті та Android."
    },
    "en": {
      "metaTitle": "Add, select and restore shops — Invemory",
      "metaDescription": "Keep a consistent personal shop catalog. Select existing shops without losing a purchase draft, resolve duplicate names and restore archived shops on web and Android."
    },
    "de": {
      "metaTitle": "Geschäfte anlegen und wiederherstellen — Invemory",
      "metaDescription": "Pflegen Sie Ihr persönliches Geschäftsverzeichnis. Wählen Sie vorhandene Geschäfte ohne Verlust des Einkaufsentwurfs und stellen Sie archivierte Einträge wieder her."
    },
    "ru": {
      "metaTitle": "Добавление и восстановление магазинов — Invemory",
      "metaDescription": "Упорядочьте личный справочник магазинов. Выбирайте существующий магазин без потери черновика покупки, проверяйте дубликаты и восстанавливайте архивные записи."
    }
  },
  "standard-color-schemes": {
    "uk": {
      "metaTitle": "Стандартні колірні схеми для адміністратора — Invemory",
      "metaDescription": "Змініть стандартні світлі й темні кольори Invemory: перевірте локальний перегляд, підтвердьте публікацію, відновіть попередні кольори та розв’яжіть конфлікт версій."
    },
    "en": {
      "metaTitle": "Standard color schemes for administrators — Invemory",
      "metaDescription": "Update Invemory’s standard Light and Dark colors. Check a local preview, confirm publication, restore the previous colors and resolve version conflicts."
    },
    "de": {
      "metaTitle": "Standardfarbschemata für Administratoren — Invemory",
      "metaDescription": "Ändern Sie die hellen und dunklen Standardfarben von Invemory. Prüfen Sie die lokale Vorschau, veröffentlichen Sie Änderungen und stellen Sie die vorherigen Farben wieder her."
    },
    "ru": {
      "metaTitle": "Стандартные цветовые схемы для администратора — Invemory",
      "metaDescription": "Измените стандартные светлые и тёмные цвета Invemory. Проверьте локальный просмотр, подтвердите публикацию, восстановите прежние цвета и разрешите конфликт версий."
    }
  },
  "storage-organization": {
    "uk": {
      "metaTitle": "Кімнати, полиці й коробки: організація місць — Invemory",
      "metaDescription": "Побудуйте структуру місць у Invemory: створіть вкладені контейнери, оновіть описи та відкрийте наявне місце, якщо контейнер із такою назвою вже є."
    },
    "en": {
      "metaTitle": "Organize rooms, shelves and boxes — Invemory",
      "metaDescription": "Organize storage in Invemory: create nested containers, update descriptions and open an existing location when a container with the same name is already there."
    },
    "de": {
      "metaTitle": "Zimmer, Regale und Boxen organisieren — Invemory",
      "metaDescription": "Organisieren Sie Lagerorte in Invemory: Untercontainer anlegen, Beschreibungen ändern und einen vorhandenen Ort öffnen, wenn der Name schon vergeben ist."
    },
    "ru": {
      "metaTitle": "Комнаты, полки и коробки: организация мест — Invemory",
      "metaDescription": "Организуйте места в Invemory: создайте вложенные контейнеры, обновите описания и откройте существующее место, если контейнер с таким названием уже есть."
    }
  },
  "write-off": {
    "uk": {
      "metaTitle": "Списання речей і перевірка залишку — Invemory",
      "metaDescription": "Спишіть цілі пакунки й частину вмісту, перевірте залишок та історію. Приклади фасованого запасу, нефасованих кг і точного списання мг у Invemory."
    },
    "en": {
      "metaTitle": "Write off items and check the balance — Invemory",
      "metaDescription": "Write off whole packages and part of their contents, then check the remainder and history. Includes packaged stock, loose kilograms and precise mg write-offs."
    },
    "de": {
      "metaTitle": "Gegenstände ausbuchen und Restmenge prüfen — Invemory",
      "metaDescription": "Ganze Packungen und Teilmengen entnehmen, Rest und Verlauf prüfen: Beispiele für verpackten Vorrat, lose Kilogramm und genaue Entnahmen in mg."
    },
    "ru": {
      "metaTitle": "Списание вещей и проверка остатка — Invemory",
      "metaDescription": "Спишите целые упаковки и часть содержимого, проверьте остаток и историю. Примеры фасованного запаса, кг без фасовки и точного списания мг в Invemory."
    }
  }
};
